/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_CodeInputs */

const vi_customer_code = /** @type {(inputs: Customer_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã KH`)
};

/**

* @param {Customer_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_code = /** @type {((inputs?: Customer_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_code(inputs)
});